import Vue from 'vue'
import toast from '@/plugins/toast'
import loading from '@/plugins/loading'
import events from '@/plugins/events'
import setTitle from '@/plugins/set-title'
import sa from '../lib/sa'
// import Raven from 'raven-js';
// import RavenVue from 'raven-js/plugins/vue';
import {
  app
} from '@beastshop/browser'
import qs from 'query-string'
import axios from '@/axios-mock'
import vconsole from 'vconsole'
import { btoa } from 'b2a'
import cookie from 'js-cookie'
const md5 = require('../lib/md5')

const isDev = process.env.NODE_ENV == 'development'
const UA = typeof navigator !== 'undefined' && navigator
  ? navigator.userAgent || ''
  : ''
const appDebug = !!~UA.indexOf('BEAST_DEBUG')
const _search = qs.parse(window.location.search)
const webDebug = 'beast_debug' in _search
if (appDebug || webDebug) {
  new vconsole()
} 
const utm_source = _search.utm_source || ''
const _cache_utm_source = window.localStorage.getItem('the_utm_source')
const cache_utm_source = _cache_utm_source ? JSON.parse(_cache_utm_source) : ''
const distinctID = _search.distinctID
let userId = window.sessionStorage.getItem('_b_m')
let miniMember = _search._mini_m

if (miniMember) {
  miniMember = JSON.parse(decodeURIComponent(miniMember))
}


if (utm_source) {
  updateUtmParam(utm_source)
  sa.thelatest_utm_source = utm_source
}
else if (!utm_source && cache_utm_source) {
  if (isMoreThanSevenDays(cache_utm_source.createTime)) {
    window.localStorage.removeItem('the_utm_source')
    sa.thelatest_utm_source = ''
  }
  else {
    sa.thelatest_utm_source = cache_utm_source.value
  }
}

if (distinctID) {
  if (miniMember && typeof miniMember === 'object') {
    sa.login(md5.hexMD5(miniMember.mobile))
  }
  sa.is_login = true
  sa.platform_type = '微信小程序'
  sa.changeIdentify(distinctID, true)
} else if (userId) {
  userId = JSON.parse(userId)
  sa.is_login = true
  sa.platform_type = 'WAP'
  sa.login(md5.hexMD5(userId.mobile))
}

sa.init()

window.sa = sa

function isMoreThanSevenDays (time) {
  const curTime = new Date().getTime()
  return curTime - time > 7 * 24 * 3600 * 1000
}

function updateUtmParam (value) {
  window.localStorage.setItem('the_utm_source', JSON.stringify({
    value,
    createTime: new Date().getTime()
  }))
}

Vue.use(toast)
Vue.use(events)
Vue.use(loading)
Vue.use(setTitle)
Vue.config.productionTip = false

exports.Page = function (page, options) {
  if (options.pageType) {
    sa.setCurrentPage(options.pageType)
  }
  sa._autoQuick()
  const vm = new Vue(options)
  return vm
}



// WEBPACK FOOTER //
// ./static/page/index.js